// extracted by mini-css-extract-plugin
export default {"widgets":"WidgetGroupContent_widgets__z33zx"};